"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const common_styled_components_1 = require("../../common-styled-components");
const useFetch_1 = __importDefault(require("../../../hooks/useFetch"));
const apiUtils_1 = require("../../../util/apiUtils");
const ComplianceKPI_1 = __importDefault(require("../common/ComplianceKPI"));
const compliance_1 = require("../../../util/compliance/compliance");
const useMetadata_1 = require("../../../hooks/useMetadata");
const theme_1 = require("../../../theme");
const react_1 = require("react");
const util_1 = require("../util");
const amountUtils_1 = require("../../../util/amountUtils");
const UsageTable_1 = require("../common/tables/UsageTable");
const YearContext_1 = require("../../../contexts/YearContext");
exports.default = () => {
    const { selectedYear } = (0, YearContext_1.useYear)();
    const { voyageId } = (0, react_router_dom_1.useParams)();
    const [metadata] = (0, useMetadata_1.useMetadata)();
    const [voyages, _setVoyagesUrl, setVoyagesPostBody] = (0, useFetch_1.default)("admin/voyages.json", undefined, true);
    const [usages, _setUsagesUrl, setUsagesPostBody] = (0, useFetch_1.default)("admin/usages.json", undefined, true);
    (0, react_1.useEffect)(() => {
        setVoyagesPostBody(JSON.stringify({
            voyage_id: Number(voyageId),
            year: selectedYear,
        }));
        setUsagesPostBody(JSON.stringify({
            voyage_id: Number(voyageId),
            year: selectedYear,
        }));
    }, [selectedYear, voyageId]);
    const [ship, _setShipUrl, setShipPostBody] = (0, useFetch_1.default)("admin/ships.json", undefined, true);
    (0, react_1.useEffect)(() => {
        if (voyages.status === apiUtils_1.LoaderStatus.Success &&
            ship.status !== apiUtils_1.LoaderStatus.Success &&
            voyages.data[0]) {
            setShipPostBody(JSON.stringify({
                ship_id: voyages.data[0].ship_id,
                year: selectedYear,
            }));
        }
    }, [voyages.status, selectedYear]);
    // const [usageAnalysis] = useFetch<ShipFuelUsages>(
    //   "admin/ship_fuel_usage.json",
    //   JSON.stringify({ ship_id: Number(shipId), year: selectedYear }),
    // );
    if (
    // ship.status !== LoaderStatus.Success ||
    voyages.status !== apiUtils_1.LoaderStatus.Success ||
        usages.status !== apiUtils_1.LoaderStatus.Success ||
        ship.status !== apiUtils_1.LoaderStatus.Success ||
        // usageAnalysis.status !== LoaderStatus.Success ||
        !metadata) {
        return (0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, { children: "Loading\u2026" });
    }
    // const shipData = ship.data[0];
    const voyageData = voyages.data[0];
    const usageData = usages.data;
    const shipData = ship.data[0];
    if (!voyageData) {
        return (0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, { children: "Voyage not found!" });
    }
    // console.log("Ship data:", shipData);
    // console.log("Voyage:", voyageData);
    // console.log(
    //   "Usage analysis:",
    //   usageAnalysis.status === LoaderStatus.Success
    //     ? usageAnalysis.data
    //     : "loading"
    // );
    // const analysis = usageAnalysis.data.ship.analysis;
    const minCellWidth = 420;
    const title = voyageData.type_id === 1
        ? `${shipData.name}: Arrival to ${voyageData.destination_name}`
        : `${shipData.name}: Port stay at ${voyageData.origin_name}`;
    return ((0, jsx_runtime_1.jsxs)(common_styled_components_1.PageContent, { align: "left", children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.ContentGrid, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SectionTitle, { children: title }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PTight, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: "Start date: " }), new Date(voyageData.start_date).toLocaleString("en-US"), ";"] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PTight, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: "End date: " }), new Date(voyageData.end_date).toLocaleString("en-US"), ";"] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PTight, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: "Distance: " }), (0, amountUtils_1.formatNumber)(voyageData.distance), " NM"] })] }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(ComplianceKPI_1.default, { compliance: (0, compliance_1.getCompliance)(voyageData.intensity.adjusted_emission_balance_ton), title: "Carbon intensity", unit: "gCO\u2082e/MJ", value: voyageData.intensity.adjusted_intensity_gCO2e_per_MJ }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(ComplianceKPI_1.default, { compliance: (0, compliance_1.getCompliance)(voyageData.intensity.adjusted_emission_balance_ton), title: "Carbon unit balance", unit: "tCO\u2082e", value: (0, util_1.scaleEmissions)(voyageData.intensity.emission_balance_ton) }) })] }), (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SmallSubtitle, { style: { marginBottom: theme_1.theme.spacing(2) }, children: "Usages" }), (0, jsx_runtime_1.jsx)(UsageTable_1.UsageTable, { usages: usageData, metadata: metadata, complianceYear: selectedYear, isInAdminTools: true })] }) })] }));
};
